namespace Gordic.Adm.WebControls.AdmKonfiguracniSkupina {

	export function openSeznamAdmKonfiguracniSkupinaProgramovaInstance(data: any) {
		$.content().navigate(["Gordic.Adm.WebControls.SeznamAdmKonfiguracniSkupinaProgramovaInstance", { ixs_usr: data.ixs_usr, typ_usr: 0 }])
	}

	export function openSeznamAdmFunkcniMistoKonfiguracniSkupina(data: any) {
		$.content().navigate("Gordic.Adm.WebControls.SeznamAdmFunkcniMistoKonfiguracniSkupina", { ixs_usr: data.ixs_usr })
	}
}